import NavItem from "./nav_item/NavItem"
import('./mapnav.scss')

export default function MapNav(opts={}){
    BaseConstructor.call(this)
    let {container, options = {},navItems=[], position={},map} = opts
    let elements = {}
    let context = this

    let lControl

    this.generate = () =>{
        lControl = L.control({position: position.position || 'topleft'})
		lControl.onAdd = function(){
            elements.l_control = L.DomUtil.create('div', `leaflet-map-nav-component ${position.orientation || 'vertical'}`);

    	    return elements.l_control;
        }
    
        lControl.addTo(map)
        generateItems()
    }

    this.update = () =>{

    }

    this.updateNavItems = items =>{
        navItems = items
        generateItems()
    }

    this.activeOnly = id =>{
        navItems.forEach(navItem=>{
            navItem.item.setActive(navItem.id === id)
        })
    }
    
    this.itemActive = (id, boolean) =>{
        navItems.forEach(navItem=>{
            if(navItem.id === id){
                navItem.item.setActive(boolean)
            }
            
        })
    }

    const generateItems = _ =>{
        $(elements.l_control).html('')
        navItems.forEach(navItem=>{
            console.log(navItem);
            
            let item = new NavItem({navItem:navItem, position: position.position, icon_options: options.icons})
            $(elements.l_control).append(item.getElement())

            item.on('nav-item-click', navItem=>{
                context.trigger('nav-item-click', navItem)
            })

            navItem.item = item
        })
    }
}

MapNav.prototype = Object.create(BaseConstructor.prototype)